import CustomCurrencyFormat from 'components/CustomCurrencyFormat';
import React from 'react';

function RecentOrdersList({ orders }) {
  return (
    <>
      <div>
        <ul className="main">
          {orders?.edges?.map((item, orderIndex) => {
            const order = item.node;
            return (
              <div key={orderIndex} className="order-item">
                {order.lineItems?.edges?.map((item, idx) => {
                  const lineItem = item.node;
                  return (
                    <div className="line-item" key={idx}>
                      <div className="rig-title">
                        {lineItem?.variant?.image?.originalSrc && (
                          <img draggable="false"
                            src={lineItem?.variant?.image?.originalSrc}
                            className="rig-icon"
                            alt="image"
                          />
                        )}
                      </div>
                      <div className="line-content">
                        <p className="line-desc">{lineItem.title || '-'}</p>

                        <ListItem label="QTY" value={lineItem.quantity || 0} />
                        <ListItem
                          label="Item Price"
                          value={
                            <CustomCurrencyFormat
                              value={lineItem?.variant?.priceV2.amount}
                            />
                          }
                        />
                      </div>
                    </div>
                  );
                })}
                <div className="order-data">
                  <div>#{order.orderNumber}</div>
                  <div className="order-total">
                    <CustomCurrencyFormat
                      value={order.totalPriceV2.amount || 0}
                    />
                  </div>
                </div>
                <a className="view-link" href={order.statusUrl}>
                  View
                </a>
              </div>
            );
          })}
        </ul>
      </div>
      <style jsx>{`
        ul {
          padding: 0;
          margin: 0;
        }
        .line-desc {
          padding: 0;
          margin: 0;
        }
        .order-data {
          display: flex;
          justify-content: space-between;
          align-items: end;
          gap: 5px;
        }
        .order-total {
          font-size: 18px;
          font-weight: 600;
          text-align: right;
        }
        .order-item {
          display: grid;
          gap: 10px;
          background-color: #141414;
          padding: 20px;
          border-radius: 10px;
        }
        .main {
          font-family: 'Roboto-Medium';
          display: grid;
          gap: 10px;
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        .rig-title {
          font-family: 'Roboto-Medium';
          font-size: 13px;
          font-weight: 600;
          line-height: 24px;
          letter-spacing: 0em;
          text-align: left;
        }
        .rig-icon {
          height: 100px;
          background-color: white;
          border-radius: 15px;
        }
        .line-item {
          display: flex;
          gap: 10px;
          align-items: start;
          border-bottom: #000000 1px solid;
          padding-bottom: 10px;
        }
        .line-content {
          flex: 1;
          display: grid;
          gap: 10px;
        }
        .view-link {
          text-decoration: underline;
          cursor: pointer;

          font-family: 'Roboto-Medium';
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          letter-spacing: 0em;
          text-align: right;
          color: #ffffff;
        }
        @media (max-width: 1259px) {
          .main {
            grid-template-columns: repeat(1, minmax(0, 1fr));
          }
        }
        @media (max-width: 944px) {
          .main {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }
        @media (max-width: 891px) {
          .main {
            grid-template-columns: repeat(1, minmax(0, 1fr));
          }
        }
      `}</style>
    </>
  );
}

function ListItem({ label, value }) {
  return (
    <li className="list-item">
      <div className="label">{label}:</div>
      <div className="value">{value}</div>
      <style jsx>
        {`
          .list-item {
            width: 100%;
            display: flex;
            font-family: 'Roboto-Medium';
            justify-content: space-between;
            gap: 10px;
            font-size: 13px;
          }
          .label {
            text-transform: uppercase;
            color: #949494;
          }
          .value {
            text-align: right;
          }
        `}
      </style>
    </li>
  );
}

export default RecentOrdersList;
